export const constants = {

    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    SET_AUTH: 'SET_AUTH',
    REMOVE_AUTH: 'REMOVE_AUTH',

    LOCAL_STORAGE_ID: "AUTH_TOKEN"

};

export default constants;
